import type { ReactNode } from 'react';

import type { LandingCopy } from './copy';
import { ArrowRightIcon } from './icons';

const icon = (children: ReactNode) => (
  <svg
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

/** One icon per step, in the same order as `steps`. */
const STEP_ICONS = [
  // chat bubble with a microphone
  icon(
    <>
      <path d="M12 3C7 3 3 6.6 3 11c0 2 .8 3.9 2.3 5.3L4.5 21l4.3-1.4c1 .3 2.1.4 3.2.4 5 0 9-3.6 9-8s-4-9-9-9Z" />
      <rect x="10.5" y="7" width="3" height="5.5" rx="1.5" />
      <path d="M9 11.5a3 3 0 0 0 6 0M12 14.5V16" />
    </>,
  ),
  // waveform becoming lines of text
  icon(
    <>
      <path d="M3 12h1M6 8v8M9 10v4" />
      <path d="M13 12h2" />
      <path d="M17 8h4M17 12h4M17 16h3" />
    </>,
  ),
  // checklist
  icon(
    <>
      <path d="m4 7 1.5 1.5L8 6M4 13l1.5 1.5L8 12M4 19l1.5 1.5L8 18" />
      <path d="M11 7h9M11 13h9M11 19h6" />
    </>,
  ),
  // ledger
  icon(
    <>
      <path d="M5 3h12a2 2 0 0 1 2 2v16H7a2 2 0 0 1-2-2V3Z" />
      <path d="M5 17a2 2 0 0 1 2-2h12M9 7h6M9 11h4" />
    </>,
  ),
];

export const HowItWorks = ({ copy }: { copy: LandingCopy['how'] }) => (
  <section id="how-it-works" className="lp-section">
    <div className="lp-container">
      <h2>{copy.title}</h2>
      <p className="lp-section__intro">{copy.intro}</p>
      <ol className="lp-steps">
        {copy.steps.map((step, i) => (
          <li key={step.title} className="lp-step">
            <div className="lp-step__icon">{STEP_ICONS[i]}</div>
            <p className="lp-step__num">
              {copy.stepLabel} {i + 1}
            </p>
            <h3>{step.title}</h3>
            <p>{step.body}</p>
            {step.note ? <p className="lp-step__note">{step.note}</p> : null}
            {/* Between the cards in a row (900px and up), pointing to the next step. */}
            {i < copy.steps.length - 1 ? (
              <span className="lp-step__arrow">
                <ArrowRightIcon />
              </span>
            ) : null}
          </li>
        ))}
      </ol>
    </div>
  </section>
);
